var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCo7Logo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M511.687 243.464C504.77 102.299 384.751 -6.54933 243.582 0.30691C102.321 7.16828 -6.61218 127.278 0.312693 268.536C7.23775 409.791 127.398 518.669 268.655 511.682C409.813 504.694 518.609 384.633 511.687 243.464ZM109.115 118.023C147.675 76.9199 197.578 56.0636 253.551 54.2999C259.815 54.2566 266.078 54.5816 272.304 55.2727C311.534 59.6843 347.352 79.6544 371.733 110.707C396.356 141.97 407.281 181.869 402.016 221.316C393.182 292.603 329.819 348.774 258.379 348.925C253.065 348.936 247.902 348.768 242.632 348.045C218.176 344.594 196.12 331.494 181.392 311.666C166.509 291.659 160.273 266.516 164.08 241.869C167.811 217.432 181.122 195.486 201.072 180.886C217.113 169.262 236.165 163.189 255.439 163.059L259.968 163.06L223.793 256.941H275.239L333.574 108.787L255.439 108.791C245.368 108.832 235.301 109.87 225.388 111.902C224.597 112.064 223.808 112.232 223.02 112.407C222.273 112.572 221.528 112.743 220.783 112.919C219.758 113.163 218.735 113.418 217.713 113.682C180.07 123.729 147.956 148.31 128.426 182.022C108.822 216.156 103.53 256.663 113.706 294.689C124.292 334.118 149.311 364.757 184.435 384.98C190.237 388.209 196.258 391.032 202.451 393.43C245.278 410.094 295.772 404.629 337.26 386.356C381.312 366.846 416.985 332.303 437.909 288.904C443.169 277.873 447.099 267.202 450.523 255.528C451.106 253.52 452.056 252.893 453.86 252.11C457.343 252.418 457.727 255.674 457.732 258.693C457.742 264.517 457.153 270.561 456.585 276.389L456.495 277.316C451.921 320.521 433.465 361.079 403.884 392.9C367.051 432.967 315.363 456.171 261.224 457.592C206.505 459.028 160.63 439.983 121.238 402.821C80.1699 364.083 56.2871 319.733 54.4512 262.904C52.5834 209.247 72.2678 157.074 109.115 118.023Z",
    fill: "url(#paint0_linear_3744_29)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.072 181.099C190.834 188.592 182.344 198.019 176 208.725V132.354C188.743 124.143 202.794 117.878 217.713 113.896C218.735 113.631 219.758 113.376 220.783 113.133C221.528 112.956 222.273 112.785 223.02 112.62C223.808 112.445 224.597 112.277 225.388 112.115C235.301 110.083 245.368 109.045 255.439 109.004L333.574 109L270 269.5H218.554L259.968 163.273L255.439 163.272C236.165 163.402 217.113 169.476 201.072 181.099Z",
    fill: "url(#paint1_linear_3744_29)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3744_29",
    x1: -118.912,
    y1: 451.815,
    x2: 564.434,
    y2: 303.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F828A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69038,
    stopColor: "#2589F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F828A6",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3744_29",
    x1: 192,
    y1: 166,
    x2: 221.5,
    y2: 177.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo7Logo);
export default __webpack_public_path__ + "static/media/CO7 Logo.3736b3c1eef71b8519d2934b56d72fdf.svg";
export { ForwardRef as ReactComponent };